import { FC } from 'react';

type Props = {
	className?: string;
};

const ApartmentIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M4.2666 7.76352C4.2666 6.10497 4.2666 5.27571 4.5527 4.60221C4.79168 4.03962 5.16885 3.55674 5.64414 3.20488C6.21313 2.78364 6.97674 2.63531 8.50396 2.33862C10.092 2.0301 10.8861 1.87584 11.504 2.12166C12.0174 2.32587 12.4499 2.71156 12.7298 3.21468C13.0667 3.82033 13.0667 4.68265 13.0667 6.4073V13.5929C13.0667 15.3175 13.0667 16.1799 12.7298 16.7855C12.4499 17.2886 12.0174 17.6743 11.504 17.8785C10.8861 18.1244 10.092 17.97 8.50396 17.6615C6.97674 17.3648 6.21313 17.2165 5.64414 16.7953C5.16885 16.4435 4.79168 15.9606 4.5527 15.3979C4.2666 14.7245 4.2666 13.8952 4.2666 12.2366V7.76352Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M13.0674 16.2386C14.2252 16.359 15.7873 16.7293 16.6174 15.6707C17.0674 15.097 17.0674 14.2229 17.0674 12.4746V7.5252C17.0674 5.77699 17.0674 4.90287 16.6174 4.32908C15.7873 3.27058 14.2252 3.64088 13.0674 3.76127'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M10.667 10.8001V9.20007'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.2676 16.1813H18.6676'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.66699 16.4001H5.06702'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ApartmentIcon;
